import axios from 'axios'
//import {eposAxios} from "@/main";
//import {epos2Axios} from "@/main";
//import router from "@/router";

export default {
    state(){
        return {
            currentStep: null,
            userId: null,
            userDetails: null,
            userWorkstation: null
        }
    },

    getters: {
        currentStep (state) {
            return state.currentStep
        }
    },

    mutations: {

    },

    actions: {
        getqrcode (qrCodeData, qrCodeParams) {
            console.log(qrCodeParams.qrcode)
            console.log(qrCodeData)
           let printLabel = '';
            const instance = axios.create({
                withCredentials: true
            })
            console.log(qrCodeParams.qrcode)
            //console.log(qrCodeData)
            let token = qrCodeData.getters.token;
            console.log(token)
            const headers = {
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": true,
                "Access-Control-Allow-Headers": 'Origin, X-Requested-With, Content-Type, Accept'
            };
            //instance.get('/api/index.php?page=ajax&function=getProductionStatusData', { headers })
            //axios('/api/index.php?page=ajax&function=getProductionStatusData', {
            axios('/api/index.php?page=ajax&function=recordBarcodeScan&barcode='+qrCodeParams.qrcode+'&type=garment&action="qc process"', {
                method: 'POST',
                withCredentials: true,
                // headers: {'Authorization': 'Bearer '+localStorage.getItem("token"),token: token}
                headers: {'Authorization': 'Bearer '+token,token: token}
            })
                .then(res => {
                    console.log(res.data)
                    console.log(qrCodeData.qrcode)
                    var binaryData = []
                    binaryData.push(res.data)
                    //window.open(URL.createObjectURL(new Blob(binaryData, {type: "application/pdf"})));
                    printLabel = 'Print Label'
                    return printLabel
                })
                .catch(error => console.log(error))
        },
        /*
        getCustomer ({commit}, customerData) {
            console.log('customerData params');
            console.log(customerData.customerId);
            const headers = { "Content-Type": "application/json" };
            axios.get('/api/index.php?page=ajax&function=getCustomer&customer_id='+customerData.customerId, { headers })
                .then(res => {
                    console.log('getCustomer response data: ')
                    console.log(res)
                })
                .catch(error => console.log(error))
        },

        getOrderByServiceTicket (serviceticketData) {
            axios.get('/api/index.php?page=ajax&function=getOrderByServiceTicket&barcode='+serviceticketData.serviceticket_id)
                .then(res => {
                    console.log('getOrderByServiceTicket response data: ')
                    console.log(res)
                })
                .catch(error => console.log(error))
        },

        */
    }
}